import React from 'react'
import './style.css'
import db from '../../database.js'
import loading from '../../img/loading.svg'
import ReactMarkdown from 'react-markdown'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {
      content: []
    }
  }
  componentDidMount () {
    var aboutRef = db.collection('about')
    aboutRef.orderBy('order', 'asc').onSnapshot(function (querySnapshot) {
      var tempCol = []
      querySnapshot.forEach(function (doc) {
        tempCol.push({
          title: doc.data().title,
          body: doc.data().body,
          order: doc.data().order
        })
        console.log(doc.id, ' => ', doc.data())
      })
      this.setState({
        content: tempCol
      })
    }.bind(this))
  }
  render () {
    var contentItems = []
    for (var bodyItem of this.state.content) {
      console.log(bodyItem)
      contentItems.push(
        <div className='aboutSection jumbotron'>
          <h2>{bodyItem.title}</h2>
          <p><ReactMarkdown source={bodyItem.body} /></p>
        </div>)
    }

    if (!contentItems || contentItems.length === 0) {
      return (<div style={{'textAlign': 'center'}} className='about-container'>
        <img alt="loading-gif" src={loading} />
      </div>)
    }

    return (
      <div className='about-container' style={{"marginTop": "25px"}}>
        {contentItems}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/About/index.js